export default {
  props: ['title', 'value']
};